import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getRoles = createAsyncThunk('roles/getRoles',
  async (_, { rejectWithValue }) => {
    try {
      const { data: { data: roles } } = await authGet('/roles');
      return roles;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getRoles;
